"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Percent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
function Percent(props) {
    return (jsx_runtime_1.jsxs(core_1.SvgIcon, __assign({}, props, { children: [jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsx("rect", { fill: "none", height: "24", width: "24" }, void 0) }, void 0),
            jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsxs("g", { children: [jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsx("path", { d: "M7.5,11C9.43,11,11,9.43,11,7.5S9.43,4,7.5,4S4,5.57,4,7.5S5.57,11,7.5,11z M7.5,6C8.33,6,9,6.67,9,7.5S8.33,9,7.5,9 S6,8.33,6,7.5S6.67,6,7.5,6z" }, void 0) }, void 0) }, void 0),
                        jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsx("rect", { height: "2", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.9706 12)", width: "20.63", x: "1.69", y: "11" }, void 0) }, void 0),
                        jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsx("path", { d: "M16.5,13c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5S18.43,13,16.5,13z M16.5,18 c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S17.33,18,16.5,18z" }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0)] }), void 0));
}
exports.Percent = Percent;
//# sourceMappingURL=Percent.js.map